import { BOMService } from "../bom-service/bom.service";
import { DungChungService } from "app/views/pages/nfc/dung-chung/__services/dung-chung.service";
import {
	Component,
	OnInit,
	Input,
	ChangeDetectionStrategy,
	HostListener,
	ElementRef,
	ViewChild,
	ChangeDetectorRef,
	ViewRef,
	Inject,
} from "@angular/core";
import {
	Observable,
	fromEvent,
	of,
	BehaviorSubject,
	ReplaySubject,
} from "rxjs";
import { distinctUntilChanged, tap, debounceTime } from "rxjs/operators";
import { Moment } from "moment";
import * as moment from "moment";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { TokenStorage } from "app/core/auth/_services/token-storage.service";
import { LayoutUtilsService } from "app/core/_base/crud/utils/layout-utils.service";
import {
	RdBoM,
	RdBoMBtp,
	RdBoMCt,
} from "../../cong-thuc-dinh-muc/cong-thuc-dinh-muc-model/cong-thuc-dinh-muc.model";
import { FunctionPublic } from "../../../dung-chung/__function/common_function";
import { SelectionModel } from "@angular/cdk/collections";
import { CommonConFig } from "../../../dung-chung/__model/common_config.model";
import {
	MatDialog,
	MatDialogRef,
	MatTableDataSource,
	MAT_DIALOG_DATA,
} from "@angular/material";

@Component({
	selector: "kt-bom-btp-dialog",
	templateUrl: "./bom-btp-dialog.component.html",
	styleUrls: ["../bom.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BOMBtpDialogComponent implements OnInit {
	CONFIG: CommonConFig;
	@ViewChild("input", { static: true }) searchInput: ElementRef;
	@ViewChild("input2", { static: true }) searchInput2: ElementRef;
	displayedColumns = ["select", "MABTP", "TENBTP"];
	dataSource = new MatTableDataSource([]);
	dataSource2 = new MatTableDataSource([]);
	selection = new SelectionModel<any>(true, []);
	selection2 = new SelectionModel<any>(true, []);
	selectedTab = 0;
	loading: boolean = false;
	constructor(
		private MainFormFB: FormBuilder,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private DungChungService: DungChungService,
		private el: ElementRef,
		private service: BOMService,
		public dialogRef: MatDialogRef<BOMBtpDialogComponent>,
		public dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	ngOnInit(): void {
        this.CONFIG = new CommonConFig();
		this.loadList();
		fromEvent(this.searchInput.nativeElement, "change")
			.pipe(
				debounceTime(150),
				distinctUntilChanged(),
				tap(() => {
					this.selectedTab = 0;
					if (this.searchInput.nativeElement.value.length >= 0)
						this.applyFilter(this.searchInput.nativeElement.value);
				})
			)
			.subscribe();

		fromEvent(this.searchInput2.nativeElement, "change")
			.pipe(
				debounceTime(150),
				distinctUntilChanged(),
				tap(() => {
					this.selectedTab = 1;
					if (this.searchInput2.nativeElement.value.length >= 0)
						this.applyFilter(this.searchInput2.nativeElement.value);
				})
			)
			.subscribe();
	}

	f_number(item: any = "0.00") {
		return FunctionPublic.F_NUMBER(item);
	}

	applyFilter(search: string) {
		this.dataSource.data = [];
		this.dataSource2.data = [];
		this.changeDetect.detectChanges();
		const filterValue = this.removeDiacritics(
			search.trim().toLowerCase().normalize("NFC")
		);
		if (this.selectedTab == 0) {
			this.dataSource.data = this.data.data
				.filter(
					(x) =>
						!x.IsBOM &&
						(x.Ma.toLowerCase()
							.normalize("NFC")
							.indexOf(filterValue) > -1 ||
							this.removeDiacritics(
								x.Ten.toLowerCase().normalize("NFC")
							).indexOf(filterValue) > -1)
				)
				.sort((a, b) => {
					return a.Ma < b.Ma ? -1 : a.Ma > b.Ma ? 1 : 0;
				});
		} else {
			if (this.selectedTab == 1) {
				this.dataSource2.data = this.data.data
					.filter(
						(x) =>
							x.IsBOM &&
							(x.Ma.toLowerCase()
								.normalize("NFC")
								.indexOf(filterValue) > -1 ||
								this.removeDiacritics(
									x.Ten.toLowerCase().normalize("NFC")
								).indexOf(filterValue) > -1)
					)
					.sort((a, b) => {
						return a.Ma < b.Ma ? -1 : a.Ma > b.Ma ? 1 : 0;
					});
			}
		}

		this.changeDetect.detectChanges();
	}

	/** Whether the number of selected elements matches the total number of rows. */
	isAllSelected() {
		const numSelected = this.selection.selected.length;
		const numRows = this.dataSource.data.length;
		return numSelected === numRows;
	}

	/** Selects all rows if they are not all selected; otherwise clear selection. */
	masterToggle() {
		this.isAllSelected()
			? this.selection.clear()
			: this.dataSource.data.forEach((row) => this.selection.select(row));
	}

	/** The label for the checkbox on the passed row */
	checkboxLabel(row?: any): string {
		if (!row) {
			return `${this.isAllSelected() ? "select" : "deselect"} all`;
		}
		return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${
			row.position + 1
		}`;
	}

	/** Whether the number of selected elements matches the total number of rows. */
	isAllSelected2() {
		const numSelected = this.selection2.selected.length;
		const numRows = this.dataSource2.data.length;
		return numSelected === numRows;
	}

	/** Selects all rows if they are not all selected; otherwise clear selection. */
	masterToggle2() {
		this.isAllSelected2()
			? this.selection2.clear()
			: this.dataSource2.data.forEach((row) =>
					this.selection2.select(row)
			  );
	}

	/** The label for the checkbox on the passed row */
	checkboxLabel2(row?: any): string {
		if (!row) {
			return `${this.isAllSelected() ? "select" : "deselect"} all`;
		}
		return `${
			this.selection2.isSelected(row) ? "deselect" : "select"
		} row ${row.position + 1}`;
	}

	back() {
		if (this.selection2.selected.length > 0) {
			this.service
				.getBOMBTP({
					listBTP: this.selection2.selected.map((x) => x.Id),
				})
				.subscribe((res) => {
					if (res && res.status == 1) {
						this.dialogRef.close({
							data: this.selection.selected.concat(
								this.selection2.selected
							),
							BOMBTP: res.data,
						});
					} else {
						this.layoutUtilsService.showErorr(
							"Không lấy được dữ liệu BOM BTP"
						);
					}
				});
		} else {
			this.dialogRef.close({
				data: this.selection.selected.concat(this.selection2.selected),
			});
		}
	}

	tabChanged() {
		this.selectedTab = this.selectedTab ? 0 : 1;
		this.loadList();
		this.changeDetect.detectChanges();
	}

	loadList() {
		if (this.selectedTab == 0) {
			this.dataSource.data = this.data.data
				.filter((x) => !x.IsBOM)
				.sort((a, b) => {
					return a.Ma < b.Ma ? -1 : a.Ma > b.Ma ? 1 : 0;
				});
			this.dataSource.data.forEach((x) => (x.LaBTP = false));
			this.data.listSelected.forEach((r) => {
				this.dataSource.data.forEach((row) => {
					if (row.Id == r) this.selection.select(row);
				});
			});
			this.searchInput.nativeElement.value = "";
		} else {
			this.dataSource2.data = this.data.data
				.filter((x) => x.IsBOM)
				.sort((a, b) => {
					return a.Ma < b.Ma ? -1 : a.Ma > b.Ma ? 1 : 0;
				});

			this.dataSource2.data.forEach((x) => (x.LaBTP = true));
			this.data.listSelected.forEach((r) => {
				this.dataSource2.data.forEach((row) => {
					if (row.Id == r) this.selection2.select(row);
				});
			});

			this.searchInput2.nativeElement.value = "";
		}
	}

	removeDiacritics(str: string) {
		if (!str) return str;
		var signs: string[] = [
			"aAeEoOuUiIdDyY",
			"áàạảãâấầậẩẫăắằặẳẵ",
			"ÁÀẠẢÃÂẤẦẬẨẪĂẮẰẶẲẴ",
			"éèẹẻẽêếềệểễ",
			"ÉÈẸẺẼÊẾỀỆỂỄ",
			"óòọỏõôốồộổỗơớờợởỡ",
			"ÓÒỌỎÕÔỐỒỘỔỖƠỚỜỢỞỠ",
			"úùụủũưứừựửữ",
			"ÚÙỤỦŨƯỨỪỰỬỮ",
			"íìịỉĩ",
			"ÍÌỊỈĨ",
			"đ",
			"Đ",
			"ýỳỵỷỹ",
			"ÝỲỴỶỸ",
		];
		for (var i = 1; i < signs.length; i++) {
			for (var j = 0; j < signs[i].length; j++) {
				str = str.replace(signs[i][j], signs[0][i - 1]);
			}
		}
		return str;
	}
}
